import { FC } from 'react'

import { SlideItemProps } from '../constants'
import { BarFiller, BarLimiter } from '../Slide/Slide.style'

import { ItemIndicator, ItemSubTitle, ItemTitle, ItemWrapper } from './SlideItem.style'

interface ItemProps {
  item: SlideItemProps
  currentKey: number
  selected: number
  setSlide: (arg: number) => void
}

const SlideItem: FC<ItemProps> = ({ item, currentKey, selected, setSlide }) => {
  const isActive = currentKey === selected
  const itPassed = currentKey > selected

  const onClick = () => {
    setSlide(currentKey)
  }

  return (
    <ItemWrapper onClick={onClick}>
      {isActive && (
        <>
          <BarFiller />
          <BarLimiter />
        </>
      )}
      <ItemIndicator isActive={isActive} itPassed={itPassed} />
      <ItemTitle isActive={isActive}>{item.title}</ItemTitle>
      <ItemSubTitle isActive={isActive}>{item.subTitle}</ItemSubTitle>
    </ItemWrapper>
  )
}

export default SlideItem
